import { AddBankAccountTask } from '../../common/tasks/AddBankAccountTask';
import { ServiceRequestSendEmailCardTask } from '../../common/tasks/ServiceRequestSendEmailCardTask';
import { ADT1FilingHandoffTask } from '../components/adt-1-filing-handoff/ADT1FilingHandoffTask';
import { ApproveCompanyDetails } from '../components/ApproveCompanyDetails';
import { UploadCACertificateTask } from '../components/auditor-appointment-form/UploadCACertificate';
import { UploadFilledADTFormTask } from '../components/auditor-appointment-form/UploadFilledADTFormTask';
import { UploadSignedADTFormTask } from '../components/auditor-appointment-form/UploadSignedADTFormTask';
import { MarkBusinessCommencementFiledTask } from '../components/business-commencement-declaration/MarkBusinessCommencementFiled';
import { UploadBankStatementForSubscriptionAmountTask } from '../components/business-commencement-declaration/UploadBankStatementTask';
import { UploadDirectorWorkingInOfficeProofTask } from '../components/business-commencement-declaration/UploadDirectorWorkingInOfficeTask';
import { UploadINC20ATask } from '../components/business-commencement-declaration/UploadINC20ATask';
import { UploadOfficeSpacePhotoTask } from '../components/business-commencement-declaration/UploadOfficeSpacePhotoTask';
import { MarkDSCFilingComplete } from '../components/director-procurement/MarkDSCFiling';
import { MarkDSCReceived } from '../components/director-procurement/MarkDSCReceived';
import { MarkDirectorMeetingCompleteTask } from '../components/director-procurement/MarkMeetingComplete';
import { ScheduleMeetingTask } from '../components/director-procurement/ScheduleMeetingTask';
import { FillCompanyDetails } from '../components/FillCompanyDetails';
import { INC20AFilingAcknowledgementTask } from '../components/inc-20a-filing/INC20AFilingAcknowledgementTask';
import { INC20AFilingTask } from '../components/inc-20a-filing/INC20AFilingTask';
import { AoaDocumentUploadTask } from '../components/incorporation-filings/AoaDocumentUploadTask';
import { CertOfIncorporationUploadTask } from '../components/incorporation-filings/CertOfIncorpUploadTask';
import { IncorporationDocumentPreparationTask } from '../components/incorporation-filings/DocumentPreparation';
import { FilingSubmittedToMCATask } from '../components/incorporation-filings/FilingSubmittedToMCA';
import { MoaDocumentUploadTask } from '../components/incorporation-filings/MoaDocumentUploadTask';
import { PanDocumentUploadTask } from '../components/incorporation-filings/PanDocumentUploadTask';
import { TanDocumentUploadTask } from '../components/incorporation-filings/TanDocumentUploadTask';
import { IncorpSignedDocumentUploadTask } from '../components/incorporation-filings/UploadSignedDocument';
import { FillNameReservationDetails } from '../components/name-reservation/FillNameReservationDetails';
import { UploadNameDocumentDetails } from '../components/name-reservation/UploadNameDocumentDetails';
import { IssueShareCertificateTask } from '../components/share-certificates/IssueShareCertificateTask';
import { SourceStamPaperTask } from '../components/share-certificates/SourceStampPaper';
import { UploadUnsignedShareCertificateTask } from '../components/share-certificates/UploadUnsignedShareCertificate';
import { IndDirectorTasks } from '../ind-directors';
import { IndPvtLtdIncorporationTasks } from './ind-pvt-ltd';

export const IND_PVT_INCORPORATION_COMPONENT_MAP = {
  [IndPvtLtdIncorporationTasks.FILL_CORPORATION_DETAILS]: FillCompanyDetails,
  [IndPvtLtdIncorporationTasks.REVIEW_CORPORATION_DETAILS]:
    ApproveCompanyDetails,
  [IndPvtLtdIncorporationTasks.COMPLETE_MCA_NAME_RESERVATION]:
    FillNameReservationDetails,
  [IndPvtLtdIncorporationTasks.UPLOAD_DOCUMENTS_FOR_MCA_NAME_RESERVATION]:
    UploadNameDocumentDetails,
  [IndPvtLtdIncorporationTasks.SEND_EMAIL_UPDATE]:
    ServiceRequestSendEmailCardTask,

  // Incorporation Filings

  [IndPvtLtdIncorporationTasks.INCORPORATION_DOCUMENT_PREPARATION]:
    IncorporationDocumentPreparationTask,
  [IndPvtLtdIncorporationTasks.CLIENT_UPLOAD_SIGNED_DOCUMENT]:
    IncorpSignedDocumentUploadTask,
  [IndPvtLtdIncorporationTasks.FILING_SUBMITTED_TO_MCA]:
    FilingSubmittedToMCATask,
  [IndPvtLtdIncorporationTasks.CLIENT_UPLOAD_CERT_OF_INCORP]:
    CertOfIncorporationUploadTask,
  [IndPvtLtdIncorporationTasks.CLIENT_UPLOAD_PAN]: PanDocumentUploadTask,
  [IndPvtLtdIncorporationTasks.CLIENT_UPLOAD_TAN]: TanDocumentUploadTask,
  [IndPvtLtdIncorporationTasks.AGENT_UPLOAD_AOA]: AoaDocumentUploadTask,
  [IndPvtLtdIncorporationTasks.AGENT_UPLOAD_MOA]: MoaDocumentUploadTask,

  // Bank Account Creation

  [IndPvtLtdIncorporationTasks.CLIENT_ADD_BANK_ACCOUNT]: AddBankAccountTask,

  // ADT-1 Filing Handoff (Agent only)
  [IndPvtLtdIncorporationTasks.ADT_1_FILING_HANDOFF]: ADT1FilingHandoffTask,

  // Share Certificate Issuance
  [IndPvtLtdIncorporationTasks.CLIENT_UPLOAD_BANK_STATEMENT_OF_SUBS_AMT]:
    UploadBankStatementForSubscriptionAmountTask,
  [IndPvtLtdIncorporationTasks.SOURCING_STAMP_PAPER]: SourceStamPaperTask,
  [IndPvtLtdIncorporationTasks.UPLOAD_ISSUE_SHARE_CERTIFICATE]:
    UploadUnsignedShareCertificateTask,
  [IndPvtLtdIncorporationTasks.UPLOAD_SIGNED_SHARE_CERTIFICATE]:
    IssueShareCertificateTask,

  // INC-20a Filing
  [IndPvtLtdIncorporationTasks.CLIENT_UPLOAD_OFFICE_SPACE]:
    UploadOfficeSpacePhotoTask,
  [IndPvtLtdIncorporationTasks.CLIENT_UPLOAD_DIRECTOR_PHOTO]:
    UploadDirectorWorkingInOfficeProofTask,
  [IndPvtLtdIncorporationTasks.INC_20A_FILING_SUBMITTED]: INC20AFilingTask,
  [IndPvtLtdIncorporationTasks.UPLOAD_INC_20A_ACKNOWLEDGEMENT]:
    INC20AFilingAcknowledgementTask,

  // Backwards compatibility: Old task IDs for existing service requests
  [IndPvtLtdIncorporationTasks.BCD_FILING_SUBMITTED]:
    MarkBusinessCommencementFiledTask,
  [IndPvtLtdIncorporationTasks.UPLOAD_INC_20A]: UploadINC20ATask,
  [IndPvtLtdIncorporationTasks.UPLOAD_SIGNED_FILLED_ADT_FORM]:
    UploadSignedADTFormTask,
  [IndPvtLtdIncorporationTasks.UPLOAD_FILLED_ADT_FORM]: UploadFilledADTFormTask,
  [IndPvtLtdIncorporationTasks.UPLOAD_CA_CERTIFICATE]: UploadCACertificateTask,

  // DSC Procurement
  [IndDirectorTasks.SCHEDULE_MEET_WITH_DSC_AGENT]: ScheduleMeetingTask,
  [IndDirectorTasks.MARK_MEETING_COMPLETE]: MarkDirectorMeetingCompleteTask,
  [IndDirectorTasks.MARK_DSC_FILING]: MarkDSCFilingComplete,
  [IndDirectorTasks.MARK_DSC_RECEIVED]: MarkDSCReceived,
};
